import React from 'react';
import { Building2, Landmark, Rocket, Handshake } from 'lucide-react';
import './Partners.css';
import SEO from '../components/SEO';

const PartnersPage = () => {
    return (
        <main className="partners-page overflow-hidden">
            <SEO
                title="Partnership & Sponsorship"
                description="Partner with Vision Sports Academy to build the future of sports in Zimbabwe. Sponsorship opportunities for corporate and individual supporters."
            />
            {/* Header */}
            <section className="partners-hero">
                <div className="container">
                    <span className="partners__eyebrow">Corporate & Individual Support</span>
                    <h1 className="partners__title">PARTNER WITH THE <span className="partners__title--accent">FUTURE</span></h1>
                    <p className="partners__subtitle">
                        We are building Harare's elite sports hub. Join us in transforming ZB Grounds and youth athletic pathways.
                    </p>
                </div>
            </section>

            {/* Strategic Need */}
            <section className="section partners-needs">
                <div className="container partners-needs__grid">
                    <div>
                        <h2 className="partners-needs__title">Why We Need <br /><span className="partners__title--accent">Your Support</span></h2>
                        <div className="partners-needs__list">
                            <div className="partners-need-item">
                                <div className="partners-need-icon"><Landmark size={24} /></div>
                                <div className="partners-need-text">
                                    <h4>Ground Renovation</h4>
                                    <p>Funding needed for elite pitch maintenance, professional drainage systems, and high-performance training areas.</p>
                                </div>
                            </div>
                            <div className="partners-need-item">
                                <div className="partners-need-icon"><Building2 size={24} /></div>
                                <div className="partners-need-text">
                                    <h4>Facility Leases</h4>
                                    <p>Long-term agreements with ZB Grounds require strategic financial backing to ensure stability for our athletes.</p>
                                </div>
                            </div>
                            <div className="partners-need-item">
                                <div className="partners-need-icon"><Rocket size={24} /></div>
                                <div className="partners-need-text">
                                    <h4>Equipment Fund</h4>
                                    <p>Providing Mako Cricket gear and pro hockey kits to talented youth from underprivileged backgrounds.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sponsorship-card">
                        <div className="sponsorship-card__header">
                            <Handshake size={60} className="sponsorship-card__icon" />
                            <h3 className="sponsorship-card__title">SPONSORSHIP <br /> PACKAGES</h3>
                            <p className="sponsorship-card__desc">Download our professional sponsorship prospectus to view branding opportunities and partnership benefits.</p>
                            <button className="btn btn-primary">Download Prospectus</button>
                        </div>
                        <div className="sponsorship-card__footer">
                            <p className="sponsorship-card__tag">Direct Donation</p>
                            <p className="sponsorship-card__note">Support our general ground renovation fund through direct donation.</p>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default PartnersPage;
